/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  REFRESH_SETUP_ASSISTANT_OUTSTANDING,
  REFRESH_SETUP_ASSISTANT_OUTSTANDING_SUCCESS,
  REFRESH_SETUP_ASSISTANT_OUTSTANDING_ERROR,
} from 'src/actions/setupAssistantActions';
import { LOGOUT } from 'src/actions/accountActions';

// outstandingCount: the verifiable Setup Assistant steps still to do, or
// null when not loaded, unknown (the server could not read the account) or
// failed. The badge shows only a positive number.
// outstandingSystemCodes: WHICH steps those are, from the same response, so
// the page's per-step markers and the sidebar number never disagree. null
// on the same terms as the count.
// showBadges: the server's "past the default-screen phase and something
// outstanding". Only true shows either badge; null / false / not loaded
// shows none.
const initialState = {
  outstandingCount: null,
  outstandingSystemCodes: null,
  showBadges: null,
  lastRequestedAt: null,
};

const setupAssistantReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REFRESH_SETUP_ASSISTANT_OUTSTANDING: {
      // The count is kept while the request is out, so the badge does not
      // flicker off and back on at every refresh.
      return produce(state, (draft) => {
        draft.lastRequestedAt = payload?.requestedAt || Date.now();
      });
    }

    case REFRESH_SETUP_ASSISTANT_OUTSTANDING_SUCCESS: {
      const outstandingCount = payload?.outstandingCount;
      const outstandingSystemCodes = payload?.outstandingSystemCodes;

      return produce(state, (draft) => {
        draft.outstandingCount = Number.isInteger(outstandingCount) ? outstandingCount : null;
        draft.outstandingSystemCodes = Array.isArray(outstandingSystemCodes)
          ? outstandingSystemCodes
          : null;
        draft.showBadges = typeof payload?.showBadges === 'boolean' ? payload.showBadges : null;
      });
    }

    case REFRESH_SETUP_ASSISTANT_OUTSTANDING_ERROR: {
      return produce(state, (draft) => {
        draft.outstandingCount = null;
        draft.outstandingSystemCodes = null;
        draft.showBadges = null;
      });
    }

    case LOGOUT: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default setupAssistantReducer;
